import type { PayrollOwedVisitDto } from '@/lib/api/payroll';

export function allVisitIds(visits: PayrollOwedVisitDto[]): Set<string> {
  return new Set(visits.map((v) => v.job_visit_employee_id));
}

export function sumSelectedPay(
  visits: PayrollOwedVisitDto[],
  selected: Set<string>,
): number {
  return visits
    .filter((v) => selected.has(v.job_visit_employee_id))
    .reduce((sum, v) => sum + v.pay_amount, 0);
}
